import { Link } from "react-router-dom";
import { Button } from "@material-ui/core";
import { axiosWithAuth } from "../Helpers/AxiosWithAuth";
import { useHistory } from "react-router";
import { useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { Create, DeleteRounded } from "@material-ui/icons";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import cx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import { useBouncyShadowStyles } from '@mui-treasury/styles/shadow/bouncy';

const styles = {
	borderRadius: "0.1rem",
	// border: "3px dotted #000000",
	padding: "10px",
	margin: "10px auto",
	width: "50%",
	// backgroundColor: "#f5f5f5",
	// backgroundOpacity: "0.2",
};

const Recipe = ({ props }) => {
	const { push } = useHistory();
	const [open, setOpen] = useState(false);

	const handleClickOpen = () => {
		setOpen(true);
	};

	const handleClose = () => {
		setOpen(false);
	};

	const handleDelete = (e) => {
		e.preventDefault();
		setOpen(false);
		axiosWithAuth()
			.delete(`/api/recipes/${props.recipe_id}`)
			.then((res) => {
				push(`/recipebook`);
			});
	};

	const useStyles = makeStyles(() => ({
		root: {
			maxWidth: 304,
			margin: 'auto',
			boxShadow: 'none',
			borderRadius: 0,
		},
		content: {
			padding: 24,
		},
		cta: {
			marginTop: 24,
			textTransform: 'initial',
		},
	}));
	
	const shadowStyles = useBouncyShadowStyles();
	
	return (
		<div className="Recipe-Conatainer" style={styles}>
			<Box sx={{ minWidth: 275, maxWidth: 675 }}>
				<Card className={cx(useStyles.root, shadowStyles.root)}>
					<Typography variant="h4" component="h2" mt={2}>
						{props.recipe_title}
					</Typography><br />
					{/* <img
						id="RecipeImage"
						width="50%"
						src={props.image}
						alt={props.recipe_title}
					/> */}
					<CardMedia
						component="img"
						height="300"
						image={props.image}
						alt={props.recipe_title}

					/>
					<Typography variant="h5" component="h5">
						Source: {props.recipe_source}
					</Typography><br />
					<Typography variant="body2" component="p" color="text.secondary" ml={6} mr={6}>
						Ingredients: {props.ingredients}
					</Typography><br />
					<Typography variant="body1" component="p" ml={4} mr={4}>
						Instructions: {props.instructions}
					</Typography><br />

					<Button 
						variant="contained" 
						color="primary" 
						startIcon={<Create />} 
						className={cx(useStyles.root, shadowStyles.root)}
					>
						<Link
							style={{ textDecoration: "none", color: "white" }}
							to={`/recipes/edit/${props.recipe_id}`}
						>
							Edit
						</Link>
					</Button><br /><br />
					<Button
						value={props.recipe_id}
						variant="contained"
						color="secondary"
						onClick={handleClickOpen}
						startIcon={<DeleteRounded />}
						className={cx(useStyles.root, shadowStyles.root)}
					>
						Delete Recipe
					</Button><br /><br />
					<Dialog
						open={open}
						onClose={handleClose}
						aria-labelledby="alert-dialog-title"
						aria-describedby="alert-dialog-description"
					>
						<DialogTitle id="alert-dialog-title">{"Delete Recipe?"}</DialogTitle>
						<DialogContent>
							<DialogContentText id="alert-dialog-description">
								Are you sure you want to delete this recipe? This cannot be undone.
							</DialogContentText>
						</DialogContent>
						<DialogActions>
							<Button onClick={handleClose}>No</Button>
							<Button onClick={handleDelete} autoFocus>
								Yes
							</Button>
						</DialogActions>
					</Dialog>
				</Card>
			</Box>
			{/* adding delete functionality here */}
		</div>
	);
};

export default Recipe;
